import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsEcommerce(tenant: Tenant): Faq[] {
	return [
		{
			question: "Jak dlouho trvá vývoj e-shopu na míru?",
			answer:
				"První verzi většinou spouštíme do 3 měsíců, základní podoba menších e-shopů bývá hotová do 6–8 týdnů. Vždy ale záleží na rozsahu daného projektu.",
		},
		{
			question: "Kolik stojí vývoj e-shopu na míru?",
			answer:
				"Cena se odvíjí od vašich požadavků na e-shop, práci naceňujeme podle ceníkové sazby za hodiny odvedené práce. Nejčastěji se částka za celé e-commerce řešení pohybuje mezi 300–500 tisíci Kč, malé e-shopy startují na částce 150 tisíc Kč. Cena vývoje komplexního e-shopu s administračním rozhraním, integracemi nebo automatizací procesů se pohybuje mezi 500 tisíci Kč a 2 miliony Kč.",
		},
		{
			question: "Kolik stojí následná podpora a údržba?",
			answer:
				"Standardní podpora je zdarma, v případě SLA (dohody o úrovni poskytování služeb) situaci řešíme individuálně.",
		},
		{
			question: "Můžeme si sami spravovat obsah e-shopu?",
			answer:
				"Ano, záleží jen na vašich požadavcích. Například správu produktů na e-shopu mívají naši zákazníci plně pod kontrolou, jiné části e-shopu bývají statické – to vám ušetří čas a sníží náklady na vývoj e-commerce řešení.",
		},
		{
			question: "Je možné do e-shopu později přidat nové funkce?",
			answer:
				"Ano, kdykoliv budete chtít, rádi do vašeho e-shopu zapracujeme nové funkcionality. Ideální je se o změnách rozhodnout na základě měření a sesbíraných dat. Vše s vámi rádi zkonzultujeme a poradíme vám.",
		},
		{
			question: "Poskytnete nám školení ohledně správy e-shopu?",
			answer: "Ano, pokud to bude potřeba, rádi vás nebo vaše zaměstnance důkladně zaškolíme.",
		},
	];
}
